// react
import React, { Suspense } from "react";

// components
import Spinner from "../../components/Spinner/ComponentLoader";

// load in the goal tree
const UserSettingsPage = React.lazy(() => import("./UserSettings"));

const UserSettingsLazyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<UserSettingsPage />
	</Suspense>
);

export default UserSettingsLazyLoader;
